import { organizationClient, twoFactorClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/vue'

const baseURL = import.meta.env.VITE_AUTH_URL ?? '/auth'

export const authClient = createAuthClient({
  baseURL,
  plugins: [organizationClient(), twoFactorClient()],
  fetchOptions: {
    credentials: 'include',
  },
})

export type AuthClient = typeof authClient
